import Cookies from 'universal-cookie';
import { UAParser } from 'ua-parser-js';
import { getDeviceType } from './device';
import env from './env';

const cookies = new Cookies();

export const segmentEnum = {
  LoggedIn: 'Logged In',
  CreateNewPassword: 'Create New Password',
  SendResetPasswordEmail: 'Send Reset Password Email',
};

/*
 * catching any errors in the imported track method call
 * and logging them because they should never effect ui
 */
export function track(eventName, trackingData) {
  try {
    var defaultData = {
      device: getDeviceType(),
    };
    var data = { ...defaultData, ...trackingData };
    window.analytics.track(eventName, data);
  } catch (e) {
    console.log(e);
  }
}

function getData(params) {
  var data = {};
  if (typeof params != 'undefined' && params.hasOwnProperty('data')) {
    data = params['data'];
  }
  return data;
}

export function clickedElement(params) {
  try {
    var dataParams = getData(params),
      defaultData = {
        device: getDeviceType(),
      },
      data = { ...defaultData, ...dataParams };

    if (
      typeof params != 'undefined' &&
      params.hasOwnProperty('target_element')
    ) {
      window.analytics.trackLink(
        params['target_element'],
        'Clicked Element',
        data
      );
    } else {
      window.analytics.track('Clicked Element', data);
    }
  } catch (e) {
    console.log(e);
  }
}

/*
 *Track user's identify
 */
export function identifyUser(userId, userTrait, forceUpdate) {
  try {
    if (forceUpdate) {
      window.analytics.identify(userId, userTrait);
      return;
    }
    var analyticsCookieValue = cookies.get('ajs_user_id');
    if (
      (analyticsCookieValue === '' ||
        analyticsCookieValue === 'null' ||
        analyticsCookieValue === '0' ||
        analyticsCookieValue !== userId) &&
      typeof userTrait != 'undefined' &&
      userId > 0
    ) {
      var contexts = getSegmentContextInfo();
      window.analytics.identify(userId, userTrait, contexts);
      createSessionInfo();
    }
  } catch (e) {
    console.log(e);
  }
}

/*
 * Track page
 */
export function trackPage(category, name, properties) {
  properties = properties || {};
  var defaultData = {
    device: getDeviceType(),
  };
  properties = { ...defaultData, ...properties };
  var sessionInfo = getSegmentSessionInfo(),
    contexts = {};
  if (sessionInfo !== undefined && sessionInfo.sessionId !== undefined) {
    properties.sessionId = sessionInfo.sessionId;
    properties.sessionCreationDate = sessionInfo.sessionCreationDate;
    properties.referrerCustom = localStorage.getItem('fff_ref');
    contexts = getSegmentContextInfo();
  }
  window.analytics.page(category, name, properties, contexts);
}

function getSegmentContextInfo() {
  var parser = new UAParser();
  var result = parser.getResult();
  var browser = {
    name: result.browser.name,
    version: result.browser.version,
  };
  var screenSize = {
    width: window.screen.width,
    height: window.screen.height,
  };
  var contexts = {
    os: result.os,
    device: result.device,
    browser: browser,
    screen: screenSize,
  };
  return contexts;
}

function getSegmentSessionInfo() {
  var sessionInfo = cookies.get('sm_session_info');
  if (sessionInfo === undefined) {
    sessionInfo = createSessionInfo();
  } else {
    cookies.set('sm_session_info', sessionInfo, {
      domain: env.originURL,
      path: '/',
      expiry: 1800,
    });
  }
  return sessionInfo;
}

function createSessionInfo() {
  var sessionId = getUuid();
  var creationDate = new Date();
  var sessionInfo = {
    sessionId: sessionId,
    sessionCreationDate: creationDate,
  };
  cookies.set('sm_session_info', JSON.stringify(sessionInfo), {
    domain: env.originURL,
    path: '/',
    expiry: 1800,
  });

  return sessionInfo;
}

function getUuid() {
  var d = new Date().getTime();
  if (
    typeof performance !== 'undefined' &&
    typeof performance.now === 'function'
  ) {
    d += performance.now(); //use high-precision timer if available
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
}
